import { Crown, Medal, Trophy } from "lucide-react";
import type { LeaderboardRow } from "@/types/database";

interface Props {
  rows: LeaderboardRow[];
}

export default function LeaderboardTable({ rows }: Props) {
  return (
    <div className="card-dark overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-steel-900/60 text-steel-300 uppercase text-xs tracking-wider">
          <tr>
            <th className="text-left p-3">Rank</th>
            <th className="text-left p-3">Student</th>
            <th className="text-left p-3 hidden sm:table-cell">School</th>
            <th className="text-left p-3 hidden md:table-cell">City</th>
            <th className="text-right p-3">Correct</th>
            <th className="text-right p-3">Time</th>
            <th className="text-right p-3">Score</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-steel-700">
          {rows.length === 0 && (
            <tr><td colSpan={7} className="p-6 text-center text-steel-300">
              No scores yet. Be the first welder on the board.
            </td></tr>
          )}
          {rows.map((r) => (
            <tr key={r.student_id + r.question_set_id} className="hover:bg-steel-800/40">
              <td className="p-3 font-display text-lg">
                <RankBadge rank={r.rank} />
              </td>
              <td className="p-3 font-medium">{r.full_name}</td>
              <td className="p-3 text-steel-300 hidden sm:table-cell">{r.school_name ?? "—"}</td>
              <td className="p-3 text-steel-300 hidden md:table-cell">{r.city ?? "—"}</td>
              <td className="p-3 text-right">{r.correct_answers}/{r.total_questions}</td>
              <td className="p-3 text-right">{fmt(r.best_time_seconds)}</td>
              <td className="p-3 text-right font-display text-base text-forge-300">{r.best_score}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function RankBadge({ rank }: { rank: number }) {
  if (rank === 1) return <span className="inline-flex items-center gap-1 text-spark"><Crown className="w-4 h-4" />1</span>;
  if (rank === 2) return <span className="inline-flex items-center gap-1 text-steel-200"><Trophy className="w-4 h-4" />2</span>;
  if (rank === 3) return <span className="inline-flex items-center gap-1 text-forge-400"><Medal className="w-4 h-4" />3</span>;
  return <span className="text-steel-300">#{rank}</span>;
}

function fmt(sec: number): string {
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
}
